import React, { useState } from 'react';
import PropTypes from 'prop-types';

import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import StructureToBase64 from './StructureToBase64';
import SwitcherTo3D from './SwitcherTo3D';
import ViewIn3D from './ViewIn3D';

import './StructureDialog.custom.scss';
import './StructureDialog.theme.scss';

export default function StructureDialog(props) {
  const { show3dButton, structure, projectName } = props;
  const [editorView, setEditorView] = useState(false);

  const captionText = projectName ? `Target structure of ${projectName}` : 'Structure';
  return (
    <GeneralDialogLayout
      {...props}
      size="fit"
      className="structure-dialog"
      contentClassName="structure-dialog--content-wrapper"
      header={
        <div className="structure-dialog--header">
          <span className="structure-dialog--header-title">{captionText}</span>
          {show3dButton && <SwitcherTo3D editorView={editorView} setEditorView={setEditorView} />}
        </div>
      }>
      {editorView ? <ViewIn3D structure={structure} /> : <StructureToBase64 {...props} />}
      <span className="structure-dialog--tip-text">Press ESC to close</span>
    </GeneralDialogLayout>
  );
}

StructureDialog.propTypes = {
  structure: PropTypes.string.isRequired,
  show3dButton: PropTypes.bool,
  projectName: PropTypes.string,
};
